/**
 * Sessão de join da videochamada (aba atual).
 * Benchmark Meet: F5 volta ao pré-join, mas a mesma pessoa reentra
 * com a mesma identity — o tile antigo some em vez de duplicar.
 */

const JOIN_IDENTITY_PREFIX = "xpro.video.joinIdentity.";

function storage() {
  try {
    return typeof sessionStorage !== "undefined" ? sessionStorage : null;
  } catch {
    return null;
  }
}

export function joinIdentityStorageKey(roomToken) {
  return `${JOIN_IDENTITY_PREFIX}${String(roomToken || "").trim()}`;
}

export function getStoredJoinIdentity(roomToken) {
  const key = joinIdentityStorageKey(roomToken);
  if (!key.endsWith(String(roomToken || "").trim()) || !String(roomToken || "").trim()) {
    return "";
  }
  try {
    return String(storage()?.getItem(key) || "").trim();
  } catch {
    return "";
  }
}

export function setStoredJoinIdentity(roomToken, identity) {
  const token = String(roomToken || "").trim();
  const id = String(identity || "").trim();
  if (!token || !id) return;
  try {
    storage()?.setItem(joinIdentityStorageKey(token), id);
  } catch {
    /* ignore */
  }
}

export function clearStoredJoinIdentity(roomToken) {
  const token = String(roomToken || "").trim();
  if (!token) return;
  try {
    storage()?.removeItem(joinIdentityStorageKey(token));
  } catch {
    /* ignore */
  }
}

export function excludeSelfFromParticipants(participants, { identity } = {}) {
  const list = Array.isArray(participants) ? participants : [];
  const self = String(identity || "").trim();
  if (!self) return list;
  return list.filter((p) => String(p?.identity || "").trim() !== self);
}
